export const GetApiBaseUrl = () =>{
    if(process.env.NODE_ENV == 'development'){
        return ''
    }

    return process.env.VUE_APP_REST_MAIN_API || ''
}

export const GetApiUrl = (path = '') =>{
    return `${GetApiBaseUrl()}${path}`
}
